import type { RefObject } from 'preact';
import cn from 'classnames';
import { useEffect } from 'preact/hooks';
import styles from './ZoomImage.module.scss';

export type ImageProps = {
  imageRef?: RefObject<HTMLImageElement>;
  alt: string;
  src: string;
  onLoad?: () => void;
  class?: string;
};
export default function Image({
  imageRef,
  src,
  alt = '',
  class: className,
  onLoad
}: ImageProps) {
  useEffect(() => {
    if (onLoad && imageRef?.current?.complete) {
      onLoad();
    }
  }, []);

  return (
    <img
      ref={imageRef}
      role="presentation"
      class={cn(styles.fullImage, styles.animation, className)}
      src={src}
      alt={alt}
      onLoad={onLoad}
    />
  );
}
